import { useAuth } from "@clerk/clerk-react";
import { useQuery } from "@tanstack/react-query";
import type { OrganisationWithRole } from "@uavity-core/api-client";
import { api } from "../api";

/**
 * Resolve the organisation scope used by the durable realtime stream.
 *
 * The Stream endpoint is organisation scoped, while the legacy browser
 * socket was user scoped. The provider opens one bounded Stream per returned
 * membership and fails closed above the provider's eight-stream fanout bound,
 * so it never silently drops an accessible organisation.
 */
export function useRealtimeOrganisation() {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: ["user", "organisations", "realtime"],
    queryFn: async (): Promise<OrganisationWithRole[]> => {
      const authToken = await getToken();
      if (!authToken) {
        throw new Error("Authentication required");
      }

      const response = await api.get<OrganisationWithRole[]>(
        "/users/me/organisations",
        { headers: { Authorization: `Bearer ${authToken}` } },
      );
      return response.data;
    },
    staleTime: 60_000,
  });
}
